(function () {
  'use strict';

  var VERSION = 'poc-0.8-guarded-cart-transform';
  var THEME_ID = '175403532324';
    var TRANSFORM_SCOPE = 'poc-v1';
  var TRANSFORM_PARENT_VARIANT_ID = '51443195707428';
  var BASE = { id: 51368794751012, title: 'Bracelet Base', price: '$10.00' };
  var VARIANTS = {
    barTtp: { id: 51368802943012, title: 'TRUST THE PROCESS', price: '$20.00' },
    barKyw: { id: 51368804319268, title: 'KNOW YOUR WHY', price: '$20.00' },
    barConsistency: { id: 51368805597220, title: 'CONSISTENCY', price: '$20.00' },
    benchmark: { id: 51368809168932, title: 'The Benchmark', price: '$10.00' },
    lightning: { id: 51368811135012, title: 'The Lightning', price: '$10.00' },
    hive: { id: 51368813101092, title: 'The Hive', price: '$10.00' },
    multiplier: { id: 51368814116900, title: 'The Multiplier', price: '$10.00' }
  };
  var PRESETS = {
    focus: { id: 'focus', title: 'FOCUS', bar: VARIANTS.barKyw, symbol1: VARIANTS.benchmark, symbol2: VARIANTS.lightning },
    growth: { id: 'growth', title: 'GROWTH', bar: VARIANTS.barConsistency, symbol1: VARIANTS.hive, symbol2: VARIANTS.multiplier },
    purpose: { id: 'purpose', title: 'PURPOSE', bar: VARIANTS.barTtp, symbol1: VARIANTS.benchmark, symbol2: VARIANTS.hive },
    'stock-failure': { id: 'stock-failure', title: 'STOCK FAILURE TEST', bar: VARIANTS.barTtp, symbol1: VARIANTS.multiplier, symbol2: VARIANTS.multiplier }
  };
  var CUSTOMER_PRESET_KEYS = ['focus', 'growth', 'purpose'];
  var STARTER_SLOTS = ['starter_base', 'starter_bar', 'starter_symbol_1', 'starter_symbol_2'];
  var UPGRADE_SLOTS = ['upgrade_symbols_1', 'upgrade_symbols_2'];

  function uid(prefix) {
    var rand = (window.crypto && crypto.randomUUID) ? crypto.randomUUID().slice(0, 8) : Math.random().toString(36).slice(2, 10);
    return prefix + '-' + Date.now().toString(36) + '-' + rand;
  }

  function props(buildId, slot, stage, offerType, instance, metadata) {
    var result = {
      _bracelet_build_id: buildId,
      _bracelet_slot: slot,
      _build_stage: stage,
      _offer_type: offerType,
      _offer_instance_id: instance,
      _builder_version: VERSION,
            _bracelet_transform_scope: TRANSFORM_SCOPE,
      _bracelet_transform_parent_variant_id: TRANSFORM_PARENT_VARIANT_ID
    };
    Object.keys(metadata || {}).forEach(function (key) {
      if (metadata[key] !== null && metadata[key] !== undefined && metadata[key] !== '') result[key] = String(metadata[key]);
    });
    return result;
  }

  function cloneChoice(choice) { return { id: choice.id, title: choice.title, price: choice.price }; }
  function selectionSignature(selection) {
    return [selection.bar && selection.bar.id, selection.symbol1 && selection.symbol1.id, selection.symbol2 && selection.symbol2.id].join(':');
  }
  function presetMetadata(presetKey, selection) {
    if (!presetKey || !PRESETS[presetKey]) return { _build_origin: 'custom_builder' };
    var preset = PRESETS[presetKey];
    var customized = selectionSignature(selection) !== selectionSignature(preset);
    return { _build_origin: 'curated_set', _curated_set_key: presetKey, _curated_set_customized: customized ? 'true' : 'false' };
  }
  function starterSelectionFromLines(lines) {
    function variantFor(slot) {
      var line = lines.find(function (candidate) { return property(candidate, '_bracelet_slot') === slot; });
      return line ? { id: Number(line.variant_id) } : null;
    }
    return {
      bar: variantFor('starter_bar'),
      symbol1: variantFor('starter_symbol_1'),
      symbol2: variantFor('starter_symbol_2')
    };
  }
  function matchingCustomerPreset(selection) {
    var signature = selectionSignature(selection);
    var key = CUSTOMER_PRESET_KEYS.find(function (presetKey) {
      return selectionSignature(PRESETS[presetKey]) === signature;
    });
    return key ? PRESETS[key] : null;
  }

  function api(path, body) {
    var options = { headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(path, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || ('Shopify returned ' + response.status));
        return data;
      });
    });
  }

  function cart() { return api('/cart.js'); }
  function add(items) { return api('/cart/add.js', { items: items }); }
  function removeKeys(keys) {
    if (!keys.length) return Promise.resolve();
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    return api('/cart/update.js', { updates: updates });
  }
  function property(item, key) { return item.properties && item.properties[key]; }
  function customerFacingCartCount(cartData) {
    var builds = {};
    var standaloneQuantity = 0;
    (cartData.items || []).forEach(function (item) {
      var buildId = property(item, '_bracelet_build_id');
      if (buildId) builds[buildId] = true;
      else standaloneQuantity += Number(item.quantity) || 0;
    });
    return Object.keys(builds).length + standaloneQuantity;
  }
  function updateCartBadge(cartData) {
    var bubbleLink = document.getElementById('cart-icon-bubble');
    if (!bubbleLink) return;
    var count = customerFacingCartCount(cartData);
    var bubble = bubbleLink.querySelector('.cart-count-bubble');
    if (!count) {
      if (bubble) bubble.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      bubbleLink.appendChild(bubble);
    }
    var visible = bubble.querySelector('[aria-hidden="true"]');
    var accessible = bubble.querySelector('.visually-hidden');
    var visibleCount = String(count);
    var accessibleCount = count + (count === 1 ? ' item' : ' items');
    if (visible && visible.textContent !== visibleCount) visible.textContent = visibleCount;
    if (accessible && accessible.textContent !== accessibleCount) accessible.textContent = accessibleCount;
  }
  var cartBadgeSyncTimer = null;
  var cartBadgeSyncRunning = false;
  function syncCustomerFacingCartBadge() {
    if (cartBadgeSyncRunning) return;
    cartBadgeSyncRunning = true;
    cart().then(updateCartBadge).catch(function () {}).finally(function () {
      cartBadgeSyncRunning = false;
    });
  }
  function scheduleCustomerFacingCartBadgeSync() {
    window.clearTimeout(cartBadgeSyncTimer);
    cartBadgeSyncTimer = window.setTimeout(syncCustomerFacingCartBadge, 60);
  }
  function mutationTouchesCartBadge(mutation) {
    if (mutation.target && mutation.target.nodeType === 1 && mutation.target.closest && mutation.target.closest('#cart-icon-bubble')) return true;
    return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
      return node.nodeType === 1 && (node.id === 'cart-icon-bubble' || (node.querySelector && node.querySelector('#cart-icon-bubble')));
    });
  }
  function initCustomerFacingCartBadge() {
    syncCustomerFacingCartBadge();
    if (!window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      if (mutations.some(mutationTouchesCartBadge)) scheduleCustomerFacingCartBadgeSync();
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
  function customerFacingBuildName(cartData, buildId) {
    var starter = buildLines(cartData, buildId).filter(function (line) {
      return STARTER_SLOTS.indexOf(property(line, '_bracelet_slot')) > -1;
    });
    if (!validStarter(starter)) return 'Your Custom Bracelet';
    var matchedPreset = matchingCustomerPreset(starterSelectionFromLines(starter));
    return matchedPreset ? matchedPreset.title : 'Your Custom Bracelet';
  }
  function openNativeCartSurface(cartData, buildId, triggeredBy, isUpgrade) {
    updateCartBadge(cartData);
    var notification = document.querySelector('cart-notification');
    var NotificationClass = window.customElements && window.customElements.get('cart-notification');
    var openMethod = NotificationClass && NotificationClass.prototype.open;
    if (!notification || typeof openMethod !== 'function') return false;
    var productTarget = notification.querySelector('#cart-notification-product');
    if (!productTarget) return false;
    var buildName = customerFacingBuildName(cartData, buildId);
    var lines = buildLines(cartData, buildId);
    var starter = lines.filter(function (line) { return STARTER_SLOTS.indexOf(property(line, '_bracelet_slot')) > -1; });
    var details = starter.map(function (line) {
      return '<li><strong>' + escapeHtml(slotLabel(property(line, '_bracelet_slot'))) + ':</strong> ' + escapeHtml(line.product_title) + '</li>';
    }).join('');
    productTarget.innerHTML = '<style>.wr-poc-notification-build{width:100%;padding:2rem 0}.wr-poc-notification-build h3{margin:0 0 .8rem}.wr-poc-notification-build p{margin:.4rem 0 1rem}.wr-poc-notification-build ul{margin:0;padding-left:1.8rem}.wr-poc-notification-build li{margin:.35rem 0}@media(max-width:749px){.wr-poc-notification-build{padding:1.5rem 0}}</style><article class="wr-poc-notification-build" data-bracelet-build-id="' + escapeHtml(buildId) + '"><h3 class="h4">' + escapeHtml(buildName) + '</h3><p>' + (isUpgrade ? 'Upgrade added to this bracelet.' : 'One complete bracelet added to your cart.') + '</p><ul>' + details + '</ul></article>';
    var setActiveElement = NotificationClass.prototype.setActiveElement;
    if (typeof setActiveElement === 'function' && triggeredBy) setActiveElement.call(notification, triggeredBy);
    openMethod.call(notification);
    return true;
  }
  function buildLines(cartData, buildId) { return cartData.items.filter(function (item) { return property(item, '_bracelet_build_id') === buildId; }); }
  function byInstance(cartData, buildId, instance) { return buildLines(cartData, buildId).filter(function (item) { return property(item, '_offer_instance_id') === instance; }); }
  function exactSlots(lines, slots) {
    return slots.every(function (slot) { return lines.filter(function (line) { return property(line, '_bracelet_slot') === slot; }).length === 1; }) && lines.length === slots.length;
  }
  function validStarter(lines) {
    if (!exactSlots(lines, STARTER_SLOTS)) return false;
    var instances = lines.map(function (line) { return property(line, '_offer_instance_id'); }).filter(Boolean);
    var oneInstance = instances.length === lines.length && instances.every(function (instance) { return instance === instances[0]; });
    return oneInstance;
  }

  function starterItems(selection, buildId, instance, stage, metadata) {
      var matchedPreset = matchingCustomerPreset(selection);
          metadata = Object.assign({}, metadata || {}, {
                _bracelet_display_name: matchedPreset ? matchedPreset.title + ' Bracelet' : 'Your Custom Bracelet',
                      _bracelet_bar_title: selection.bar.title,
                            _bracelet_symbol_1_title: selection.symbol1.title,
                                  _bracelet_symbol_2_title: selection.symbol2.title,
                                        _starter_symbol_2_discount_percent: '25'
                                            });
                                                return [
      { id: BASE.id, quantity: 1, properties: props(buildId, 'starter_base', stage, 'starter', instance, metadata) },
      { id: selection.bar.id, quantity: 1, properties: props(buildId, 'starter_bar', stage, 'starter', instance, metadata) },
      { id: selection.symbol1.id, quantity: 1, properties: props(buildId, 'starter_symbol_1', stage, 'starter', instance, metadata) },
      { id: selection.symbol2.id, quantity: 1, properties: props(buildId, 'starter_symbol_2', stage, 'starter', instance, metadata) }
    ];
  }

  function rollbackInstance(buildId, instance) {
    return cart().then(function (c) { return removeKeys(byInstance(c, buildId, instance).map(function (line) { return line.key; })); });
  }

  function addAndVerify(buildId, instance, items, expectedSlots) {
    return add(items).then(function () { return cart(); }).then(function (c) {
      var lines = byInstance(c, buildId, instance);
      if (!exactSlots(lines, expectedSlots)) throw new Error('Cart reconciliation failed: expected slots were not found.');
      return c;
    }).catch(function (error) {
      return rollbackInstance(buildId, instance).catch(function () {}).then(function () { throw error; });
    });
  }

  function replaceOffer(buildId, oldInstance, newInstance, newItems, slots) {
    return addAndVerify(buildId, newInstance, newItems, slots).then(function (afterAdd) {
      var oldKeys = byInstance(afterAdd, buildId, oldInstance).map(function (line) { return line.key; });
      return removeKeys(oldKeys).then(function () { return cart(); }).then(function (afterRemove) {
        if (!exactSlots(byInstance(afterRemove, buildId, newInstance), slots) || byInstance(afterRemove, buildId, oldInstance).length) {
          throw new Error('The replacement could not be verified.');
        }
        return afterRemove;
      }).catch(function (error) {
        return rollbackInstance(buildId, newInstance).catch(function () {}).then(function () { throw error; });
      });
    });
  }

  function builderUrl(params) {
    var url = new URL('/products/test-bracelet-base', window.location.origin);
    url.searchParams.set('view', 'bracelet-builder-poc');
    url.searchParams.set('preview_theme_id', THEME_ID);
    Object.keys(params || {}).forEach(function (key) { if (params[key]) url.searchParams.set(key, params[key]); });
    return url.pathname + url.search;
  }

  function cartUrl() { return '/cart?preview_theme_id=' + THEME_ID; }

  function initHomepagePresets() {
    document.querySelectorAll('[data-wr-shop-set]').forEach(function (button) {
      if (button.getAttribute('data-wr-cart-bound') === 'true') return;
      button.setAttribute('data-wr-cart-bound', 'true');
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var key = button.getAttribute('data-wr-shop-set');
        var preset = PRESETS[key];
        var section = button.closest('.wr-curated');
        var status = section && section.querySelector('[data-wr-curated-status]');
        function say(text, isError) {
          if (!status) return;
          status.textContent = text || '';
          status.classList.toggle('is-error', !!isError);
        }
        if (!preset) { say('This combination could not be resolved.', true); return; }
        button.disabled = true;
        say('Adding and verifying the ' + preset.title + ' bracelet…');
        var buildId = uid('wrb');
        var instance = uid('starter');
        var metadata = presetMetadata(key, preset);
        addAndVerify(buildId, instance, starterItems(preset, buildId, instance, 'starter', metadata), STARTER_SLOTS).then(function (cartData) {
          say(preset.title + ' was added to your cart.');
          openNativeCartSurface(cartData, buildId, button, false);
        }).catch(function (error) {
          say(error.message + ' No partial bracelet was left in the cart.', true);
        }).finally(function () { button.disabled = false; });
      });
    });
  }

  function initBuilder() {
    var root = document.getElementById('wr-bracelet-builder');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var editBuild = params.get('edit_build');
    var upgradeBuild = params.get('upgrade_build');
    var editUpgrade = params.get('edit_upgrade');
    var presetKey = params.get('preset');
    var state = { bar: null, symbol1: null, symbol2: null, upgrade1: null, upgrade2: null };
    var currentBuild = editBuild || upgradeBuild || null;
    var oldStarterInstance = null;
    var busy = false;

    var message = root.querySelector('[data-message]');
    var progress = root.querySelector('.wr-poc__progress');
    function say(text, isError) { message.textContent = text || ''; message.classList.toggle('is-error', !!isError); }
    function show(name) {
      root.querySelectorAll('[data-panel]').forEach(function (panel) { panel.hidden = panel.getAttribute('data-panel') !== name; });
      root.querySelectorAll('[data-progress]').forEach(function (step) { step.classList.toggle('is-active', step.getAttribute('data-progress') === name); });
      if (name.indexOf('upgrade') === 0 || name === 'success') progress.hidden = true;
      else progress.hidden = false;
      window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
    }
    function choiceFrom(button) { return { id: Number(button.getAttribute('data-variant-id')), title: button.getAttribute('data-title'), price: button.getAttribute('data-price') || '' }; }
    function select(field, button) {
      var panel = button.closest('[data-panel]');
      panel.querySelectorAll('[data-choice="' + field + '"]').forEach(function (candidate) { candidate.classList.toggle('is-selected', candidate === button); });
      state[field] = choiceFrom(button);
      var next = panel.querySelector('[data-next], [data-add-upgrade]');
      if (next) next.disabled = false;
    }
    function markSelected(field) {
      if (!state[field]) return;
      root.querySelectorAll('[data-choice="' + field + '"]').forEach(function (button) {
        button.classList.toggle('is-selected', Number(button.getAttribute('data-variant-id')) === Number(state[field].id));
      });
      var panel = root.querySelector('[data-panel="' + field + '"]');
      if (panel) { var next = panel.querySelector('[data-next], [data-add-upgrade]'); if (next) next.disabled = false; }
    }
    function review() {
      var target = root.querySelector('[data-summary]');
      var cards = [
        '<article><small>Included automatically</small><strong>Bracelet Base</strong><span>$10.00 TEST</span></article>',
        '<article><small>Bar</small><strong>' + state.bar.title + '</strong><span>' + state.bar.price + ' TEST</span></article>',
        '<article><small>Symbol one · required</small><strong>' + state.symbol1.title + '</strong><span>' + state.symbol1.price + ' TEST</span></article>'
      ];
      cards.push('<article><small>Symbol two · required</small><strong>' + state.symbol2.title + '</strong><span>' + state.symbol2.price + ' TEST</span></article>');
      target.innerHTML = cards.join('');
    }
    function upgradeItems(buildId, instance) {
      return [
        { id: state.upgrade1.id, quantity: 1, properties: props(buildId, 'upgrade_symbols_1', 'upgrade-active', 'switch_symbols', instance) },
        { id: state.upgrade2.id, quantity: 1, properties: props(buildId, 'upgrade_symbols_2', 'upgrade-active', 'switch_symbols', instance) }
      ];
    }
    function success(title, copy) {
      var successTitle = root.querySelector('[data-success-title]');
      say('', false);
      successTitle.textContent = title;
      root.querySelector('[data-success-copy]').textContent = copy;
      root.querySelector('[data-cart-link]').href = cartUrl();
      root.querySelector('[data-add-upgrade-link]').hidden = !currentBuild;
      show('success');
      successTitle.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-choice]');
      if (choice) { select(choice.getAttribute('data-choice'), choice); return; }
      var next = event.target.closest('[data-next]');
      if (next && !next.disabled) {
        var panel = next.getAttribute('data-next');
        if (panel === 'review') review();
        show(panel); return;
      }
      var back = event.target.closest('[data-back]');
      if (back) { show(back.getAttribute('data-back')); return; }
      if (event.target.closest('[data-add-upgrade-link]')) { window.location.href = builderUrl({ upgrade_build: currentBuild }); }
      var customize = event.target.closest('[data-customize-set]');
      if (customize) { window.location.href = builderUrl({ preset: customize.getAttribute('data-customize-set') }); }
    });

    root.querySelectorAll('[data-shop-set]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (busy) return;
        var key = button.getAttribute('data-shop-set');
        var preset = PRESETS[key];
        if (!preset) { say('This preset could not be resolved.', true); return; }
        busy = true; button.disabled = true; say('Adding and reconciling the ' + preset.title + ' components…');
        var buildId = uid('wrb');
        var instance = uid('starter');
        var metadata = presetMetadata(key, preset);
        addAndVerify(buildId, instance, starterItems(preset, buildId, instance, 'starter', metadata), STARTER_SLOTS).then(function (cartData) {
          currentBuild = buildId;
          success('Bracelet added to your cart', preset.title + ' was added successfully.');
          openNativeCartSurface(cartData, buildId, button, false);
        }).catch(function (error) {
          say(error.message + ' No partial staged build was intentionally left in the cart.', true);
        }).finally(function () { busy = false; button.disabled = false; });
      });
    });

    root.querySelector('[data-add-starter]').addEventListener('click', function (event) {
      if (busy || !state.bar || !state.symbol1 || !state.symbol2) return;
      busy = true; say('Adding and reconciling 4 physical components…');
      var buildId = editBuild || uid('wrb');
      var instance = uid('starter');
      var metadata = presetMetadata(presetKey, state);
      if (editBuild && !presetKey) metadata = state.metadata || { _build_origin: 'custom_builder' };
      var items = starterItems(state, buildId, instance, editBuild ? 'starter-edit-active' : 'starter', metadata);
      var work = editBuild ? replaceOffer(buildId, oldStarterInstance, instance, items, STARTER_SLOTS) : addAndVerify(buildId, instance, items, STARTER_SLOTS);
      work.then(function (cartData) { currentBuild = buildId; updateCartBadge(cartData); success(editBuild ? 'Bracelet updated' : 'Bracelet added to your cart', editBuild ? 'Your bracelet changes were saved successfully.' : 'Your bracelet was added successfully.'); if (!editBuild) openNativeCartSurface(cartData, buildId, event.currentTarget, false); }).catch(function (error) { say(error.message + ' No partial staged build was intentionally left in the cart.', true); }).finally(function () { busy = false; });
    });

    root.querySelector('[data-add-upgrade]').addEventListener('click', function (event) {
      if (busy || !currentBuild || !state.upgrade1 || !state.upgrade2) return;
      busy = true; say('Adding and reconciling the two upgrade Symbols…');
      var instance = uid('switch-symbols');
      var work = editUpgrade ? replaceOffer(currentBuild, editUpgrade, instance, upgradeItems(currentBuild, instance), UPGRADE_SLOTS) : addAndVerify(currentBuild, instance, upgradeItems(currentBuild, instance), UPGRADE_SLOTS);
      work.then(function (cartData) { updateCartBadge(cartData); success(editUpgrade ? 'Upgrade updated' : 'Upgrade added to your bracelet', 'The Symbol upgrade was added successfully.'); if (!editUpgrade) openNativeCartSurface(cartData, currentBuild, event.currentTarget, true); }).catch(function (error) { say(error.message + ' No partial staged upgrade was intentionally left in the cart.', true); }).finally(function () { busy = false; });
    });

    if (editUpgrade) {
      currentBuild = editBuild;
      root.querySelectorAll('[data-panel]').forEach(function (panel) { panel.hidden = true; });
      say('Reconstructing the existing Symbol upgrade from the Shopify cart…');
      cart().then(function (c) {
        var lines = byInstance(c, currentBuild, editUpgrade);
        if (!exactSlots(lines, UPGRADE_SLOTS)) throw new Error('This upgrade is incomplete and cannot be safely edited automatically.');
        var find = function (slot) { return lines.find(function (line) { return property(line, '_bracelet_slot') === slot; }); };
        state.upgrade1 = { id: find('upgrade_symbols_1').variant_id, title: find('upgrade_symbols_1').product_title, price: '' };
        state.upgrade2 = { id: find('upgrade_symbols_2').variant_id, title: find('upgrade_symbols_2').product_title, price: '' };
        ['upgrade1', 'upgrade2'].forEach(markSelected); say('Existing upgrade reconstructed from the Shopify cart.'); show('upgrade1');
      }).catch(function (error) { say(error.message, true); show('upgrade1'); });
      return;
    }
    if (upgradeBuild) { currentBuild = upgradeBuild; show('upgrade1'); return; }
    if (editBuild) {
      root.querySelectorAll('[data-panel]').forEach(function (panel) { panel.hidden = true; });
      say('Reconstructing the existing bracelet from the Shopify cart…');
      cart().then(function (c) {
        var starter = buildLines(c, editBuild).filter(function (line) { return STARTER_SLOTS.indexOf(property(line, '_bracelet_slot')) > -1; });
        if (!validStarter(starter)) throw new Error('This Starter is incomplete and cannot be safely edited automatically.');
        oldStarterInstance = property(starter[0], '_offer_instance_id');
        var find = function (slot) { return starter.find(function (line) { return property(line, '_bracelet_slot') === slot; }); };
        state.bar = { id: find('starter_bar').variant_id, title: find('starter_bar').product_title, price: '' };
        state.symbol1 = { id: find('starter_symbol_1').variant_id, title: find('starter_symbol_1').product_title, price: '' };
        state.symbol2 = { id: find('starter_symbol_2').variant_id, title: find('starter_symbol_2').product_title, price: '' };
        state.metadata = {
          _build_origin: property(starter[0], '_build_origin') || 'custom_builder',
          _curated_set_key: property(starter[0], '_curated_set_key') || '',
          _curated_set_customized: property(starter[0], '_curated_set_customized') || ''
        };
        presetKey = state.metadata._curated_set_key || null;
        ['bar', 'symbol1', 'symbol2'].forEach(markSelected); review(); say('Existing selections reconstructed from the Shopify cart.'); show('review');
      }).catch(function (error) { say(error.message, true); show('bar'); });
      return;
    }
    if (presetKey && PRESETS[presetKey]) {
      var selectedPreset = PRESETS[presetKey];
      state.bar = cloneChoice(selectedPreset.bar);
      state.symbol1 = cloneChoice(selectedPreset.symbol1);
      state.symbol2 = cloneChoice(selectedPreset.symbol2);
      ['bar', 'symbol1', 'symbol2'].forEach(markSelected);
      say(selectedPreset.title + ' loaded. You can change any selection before adding it to your bag.');
    } else if (presetKey) {
      say('The requested curated combination could not be found. Start with a blank bracelet instead.', true);
      presetKey = null;
    }
    show('bar');
  }

  function escapeHtml(value) { var div = document.createElement('div'); div.textContent = String(value || ''); return div.innerHTML; }
  function slotLabel(slot) {
    return {
      starter_base: 'Bracelet Base',
      starter_bar: 'Bar',
      starter_symbol_1: 'Symbol 1',
      starter_symbol_2: 'Symbol 2',
      upgrade_symbols_1: 'Upgrade Symbol 1',
      upgrade_symbols_2: 'Upgrade Symbol 2'
    }[slot] || slot;
  }
  function money(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100); }
    catch (error) { return ((cents || 0) / 100).toFixed(2); }
  }
  function hideNativeBuildLines(cartData) {
    cartData.items.forEach(function (line, index) {
      if (!property(line, '_bracelet_build_id')) return;
      ['CartItem-' + (index + 1), 'CartDrawer-Item-' + (index + 1)].forEach(function (id) {
        var row = document.getElementById(id);
        if (row) {
          row.hidden = true;
          row.style.setProperty('display', 'none', 'important');
          row.setAttribute('aria-hidden', 'true');
          row.querySelectorAll('button,input,a[href*="/cart/change"]').forEach(function (control) {
            control.setAttribute('tabindex', '-1');
            if ('disabled' in control) control.disabled = true;
          });
        }
      });
    });
  }
  function initCartGroups() {
    if (window.location.pathname !== '/cart') return;
    cart().then(function (c) {
      var grouped = {};
      c.items.forEach(function (line) {
        var id = property(line, '_bracelet_build_id');
        if (!id) return;
        if (!grouped[id]) grouped[id] = [];
        grouped[id].push(line);
      });
      var ids = Object.keys(grouped);
      if (!ids.length) return;
      hideNativeBuildLines(c);
      var shell = document.createElement('section');
      shell.id = 'wr-poc-cart-groups';
      shell.setAttribute('aria-labelledby', 'wr-poc-cart-groups-title');
      shell.innerHTML = '<style>#wr-poc-cart-groups{width:100%;margin:24px 0;padding:0}#wr-poc-cart-groups .wr-group{border:2px solid #222;padding:18px;margin:14px 0;background:#faf8f4}#wr-poc-cart-groups ul{padding-left:20px}#wr-poc-cart-groups .wr-build-total{font-size:1.1em;font-weight:700}#wr-poc-cart-groups .wr-actions{display:flex;flex-wrap:wrap;gap:10px}#wr-poc-cart-groups a,#wr-poc-cart-groups button{min-height:44px;padding:10px 14px;border:1px solid #222;background:#fff;color:#111;text-decoration:none;cursor:pointer}#wr-poc-cart-groups a:focus-visible,#wr-poc-cart-groups button:focus-visible{outline:3px solid #1a73e8;outline-offset:2px}#wr-poc-cart-groups button[data-remove-build]{border-color:#8b1e1e;color:#8b1e1e}#wr-poc-cart-groups button:disabled{opacity:.5;cursor:wait}#wr-poc-cart-groups .wr-warning{color:#8b1e1e;font-weight:700}@media(max-width:640px){#wr-poc-cart-groups{margin:18px 0}#wr-poc-cart-groups .wr-actions{display:grid}#wr-poc-cart-groups .wr-actions>*{width:100%;text-align:center}}</style><h2 id="wr-poc-cart-groups-title">Your bracelets</h2><p>Each bracelet is managed as one complete build. Standalone Bars or Symbols remain separate cart items below.</p>';
      ids.forEach(function (id, index) {
        var lines = grouped[id];
        var starter = lines.filter(function (line) { return STARTER_SLOTS.indexOf(property(line, '_bracelet_slot')) > -1; });
        var validStarterBuild = validStarter(starter);
        var offers = {};
        lines.filter(function (line) { return property(line, '_offer_type') === 'switch_symbols'; }).forEach(function (line) {
          var instance = property(line, '_offer_instance_id') || 'missing-instance';
          if (!offers[instance]) offers[instance] = [];
          offers[instance].push(line);
        });
        var card = document.createElement('article');
        card.className = 'wr-group';
        var starterHtml = starter.map(function (line) { return '<li><strong>' + escapeHtml(slotLabel(property(line, '_bracelet_slot'))) + ':</strong> ' + escapeHtml(line.product_title) + '</li>'; }).join('');
        var buildTotal = lines.reduce(function (sum, line) { return sum + (line.final_line_price || 0); }, 0);
        var matchedPreset = validStarterBuild ? matchingCustomerPreset(starterSelectionFromLines(starter)) : null;
        var displayName = validStarterBuild ? (matchedPreset ? matchedPreset.title : 'Your Custom Bracelet') : 'Incomplete Bracelet';
        card.setAttribute('data-build-origin', starter[0] && property(starter[0], '_build_origin') || 'unknown');
        card.setAttribute('data-display-name', displayName);
        var offerHtml = Object.keys(offers).map(function (instance) {
          var offerLines = offers[instance];
          var valid = exactSlots(offerLines, UPGRADE_SLOTS);
          var titles = offerLines.map(function (line) { return escapeHtml(line.product_title); }).join(' + ');
          return '<div><strong>Switch the Symbols:</strong> ' + titles + (valid ? '' : ' <span class="wr-warning">Incomplete — manual cleanup required</span>') + '<div class="wr-actions">' + (valid ? '<a href="' + builderUrl({ edit_build: id, edit_upgrade: instance }) + '">Edit upgrade</a>' : '') + '<button type="button" data-remove-upgrade="' + escapeHtml(instance) + '" data-build="' + escapeHtml(id) + '">Remove this upgrade</button></div></div>';
        }).join('');
        card.innerHTML = '<h3>' + escapeHtml(displayName) + '</h3><small>Bracelet ' + (index + 1) + ' · Build ID: ' + escapeHtml(id) + '</small>' + (validStarterBuild ? '<ul>' + starterHtml + '</ul><p class="wr-build-total">Bracelet total: ' + escapeHtml(money(buildTotal, c.currency)) + '</p><div class="wr-actions"><a href="' + builderUrl({ edit_build: id }) + '">Edit Bracelet</a><a href="' + builderUrl({ upgrade_build: id }) + '">Add Switch the Symbols</a><button type="button" data-remove-build="' + escapeHtml(id) + '">Remove Bracelet</button></div>' : '<p class="wr-warning">This bracelet is incomplete. Automatic editing is disabled; remove the bracelet as a group and rebuild it.</p><ul>' + starterHtml + '</ul><div class="wr-actions"><button type="button" data-remove-build="' + escapeHtml(id) + '">Remove Bracelet</button></div>') + offerHtml;
        shell.appendChild(card);
      });
      var hasStandaloneItems = c.items.some(function (line) { return !property(line, '_bracelet_build_id'); });
      function mountInsideCart() {
        var dedicatedMount = document.getElementById('wr-poc-cart-groups-mount');
        var nativeItems = document.getElementById('main-cart-items');
        var cartItemsRoot = document.querySelector('cart-items');
        var cartPageWidth = cartItemsRoot && cartItemsRoot.querySelector('.page-width');
        if (dedicatedMount && !shell.isConnected) dedicatedMount.appendChild(shell);
        else if (cartPageWidth && nativeItems && !shell.isConnected) cartPageWidth.insertBefore(shell, nativeItems);
        else if (!shell.isConnected) {
          var main = document.querySelector('main');
          if (main) main.insertBefore(shell, main.firstChild);
        }
        if (nativeItems && !hasStandaloneItems) {
          nativeItems.hidden = true;
          nativeItems.style.setProperty('display', 'none', 'important');
          nativeItems.setAttribute('aria-hidden', 'true');
        }
      }
      mountInsideCart();
      window.setTimeout(mountInsideCart, 500);
      window.setTimeout(mountInsideCart, 1500);
      var cartHost = document.documentElement;
      if (cartHost && window.MutationObserver) {
        new MutationObserver(function () {
          if (!shell.isConnected) window.requestAnimationFrame(mountInsideCart);
        }).observe(cartHost, { childList: true, subtree: true });
      }
      shell.addEventListener('click', function (event) {
        var buildButton = event.target.closest('[data-remove-build]');
        if (buildButton) {
          var buildId = buildButton.getAttribute('data-remove-build');
          if (!window.confirm('Remove this complete bracelet and all of its grouped components from your bag?')) return;
          buildButton.disabled = true;
          buildButton.textContent = 'Removing bracelet…';
          cart().then(function (latest) {
            return removeKeys(buildLines(latest, buildId).map(function (line) { return line.key; }));
          }).then(function () { return cart(); }).then(function (afterRemove) {
            if (buildLines(afterRemove, buildId).length) throw new Error('The complete bracelet could not be removed safely.');
            window.location.reload();
          }).catch(function (error) {
            buildButton.disabled = false;
            buildButton.textContent = 'Remove Bracelet';
            window.alert(error.message);
          });
          return;
        }
        var button = event.target.closest('[data-remove-upgrade]');
        if (!button) return;
        button.disabled = true;
        cart().then(function (latest) {
          var keys = byInstance(latest, button.getAttribute('data-build'), button.getAttribute('data-remove-upgrade')).map(function (line) { return line.key; });
          return removeKeys(keys);
        }).then(function () { window.location.reload(); }).catch(function (error) { button.disabled = false; window.alert(error.message); });
      });
    }).catch(function (error) { console.error('Bracelet POC grouping failed', error); });
  }

  function boot() { initCustomerFacingCartBadge(); initHomepagePresets(); initBuilder(); initCartGroups(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
